module.exports = __webpack_public_path__ + "img/Smart_Tales_Icon.e7b81dae.png";